
let db = null;

const initDatabase = () => {
    return new Promise((resolve, reject) => {
        document.addEventListener("deviceready", () => {
            if (!db) {
                db = window.sqlitePlugin.openDatabase({ name: 'materials.db', location: 'default' });
                db.transaction((tx) => {
                    tx.executeSql('CREATE TABLE IF NOT EXISTS materials (fileId TEXT PRIMARY KEY, userId TEXT, filename TEXT, filetype TEXT, filepath TEXT, filesize INTEGER, filedata BLOB, fileLocation TEXT, subject TEXT, timestamp DATETIME DEFAULT CURRENT_TIMESTAMP)');
                }, (error) => {
                    console.error('SQLite Error during table creation:', error);
                    reject(error);
                }, () => {
                    console.log('Database initialized successfully');
                    resolve(db);
                });
            } else {
                resolve(db);
            }
        });
    });
};

// Method to insert material data into the database
const insertMaterial = (material) => {
    console.log(material,'===material in insertMaterial ');
    return new Promise((resolve, reject) => {
        db.transaction((tx) => {
            tx.executeSql(
                'INSERT OR REPLACE INTO materials (fileId, userId, filename, filetype, filepath, filesize, filedata, fileLocation, subject) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)',
                [
                    material.fileId,
                    material.userId,
                    material.filename,
                    material.filetype,
                    material.filepath,
                    material.filesize,
                    material.filedata,
                    material.fileLocation,
                    material.subject,
                ],
                (result) => {
                    console.log('Material inserted successfully');
                    resolve(result);
                },
                (error) => {
                    console.error('SQLite insert error:', error);
                    reject(error);
                }
            );
        });
    });
};

const fetchMaterials = (page, limit, userId) => {
    return new Promise((resolve, reject) => {

        const offset = (page - 1) * limit;

        db.transaction((tx) => {
            const sqlMaterials = `SELECT * FROM materials WHERE userId = ? ORDER BY timestamp DESC LIMIT ? OFFSET ?`;
            tx.executeSql(sqlMaterials, [userId, limit, offset], (tx, resultSet) => {
                const materials = [];
                for (let i = 0; i < resultSet.rows.length; i++) {
                    const material = resultSet.rows.item(i);
                    console.log(material.filedata, '========material.filedata');                   
                    materials.push(material);
                }

                const sqlTotal = `SELECT COUNT(*) as total FROM materials WHERE userId = ?`;
                tx.executeSql(sqlTotal, [userId], (tx, countResultSet) => {
                    const total = countResultSet.rows.item(0).total;

                    resolve({ materials, total });
                }, (error) => {
                    console.error('Error fetching total count:', error);
                    reject(error);
                });

            }, (error) => {
                console.error('Error fetching materials:', error);
                reject(error);
            });
        });
    });
};


const deleteMaterial = (fileId) => {
    return new Promise((resolve, reject) => {
        db.transaction((tx) => {
            tx.executeSql(
                'DELETE FROM materials WHERE fileId = ?',
                [fileId],
                (result) => {
                    console.log(`Material with fileId ${fileId} deleted successfully`);
                    resolve(result);
                },
                (error) => {
                    console.error('SQLite delete error:', error);
                    reject(error);
                }
            );
        });
    });
};

const checkFileStatusInDatabase = (fileId, userId, categoryName) => {
    console.log(fileId, userId, categoryName, '========props for file existence');
    return new Promise((resolve) => {
        const likeCategoryName = categoryName ? `%${categoryName}%` : '%';
        db.transaction((tx) => {
            tx.executeSql(
                `SELECT COUNT(*) as count FROM materials WHERE fileId = ? AND userId = ? AND fileLocation LIKE ?`,
                [fileId, userId, likeCategoryName],
                (tx, resultSet) => { // Correctly defined success callback
                    console.log(resultSet, '======resultSet');
                    if (resultSet.rows.length > 0) { // Ensure rows exist
                        const count = resultSet.rows.item(0).count;
                        console.log(count, '===count');
                        resolve({ success: true, exists: count > 0 });
                    } else {
                        console.warn('No rows returned in resultSet');
                        resolve({ success: false, exists: false });
                    }
                },
                (tx, error) => {
                    console.error('Error checking file status:', error);
                    resolve({ success: false, error: 'Failed to check file status' });
                }
            );
        }, (error) => {
            console.error('Transaction error:', error);
            resolve({ success: false, error: 'Transaction failed' });
        }, () => {
            console.log('Transaction completed successfully');
        });
    });
};


export { initDatabase, insertMaterial, fetchMaterials, deleteMaterial, checkFileStatusInDatabase};
